import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { FileText, Zap, Brain } from 'lucide-react';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative pt-24 pb-12 md:pt-28 md:pb-16 overflow-hidden" data-id="element-114">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-115" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-116">
        <motion.div className="max-w-4xl mx-auto text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-117">
          <motion.div variants={itemVariants} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700 text-sm font-medium text-slate-300 mb-5" data-id="element-118">
            <span aria-hidden="true" data-id="element-119">😴</span> CLOSE THE GAP™
          </motion.div>

          <motion.h1 variants={itemVariants} className="md:text-6xl font-display text-white mb-5 text-balance font-[700] text-[48px]" data-id="element-120">
            Potencia tu descanso Cambia tu vida
          </motion.h1>

          {/* Mockup del producto */}
          <motion.div variants={itemVariants} className="mb-6" data-id="element-121">
            <div className="relative mx-auto max-w-md md:max-w-lg" data-id="element-122">
              <div className="absolute inset-0 bg-amber-500/15 rounded-full blur-[100px] pointer-events-none" data-id="element-123" />
              <img src="https://cdn.magicpatterns.com/uploads/k5kXyyXWSwe671nkQ3ywFQ/Mockup_-_Megapack_Biohacking_del_sueno.png" alt="Megapack Biohacking del Sueño — 6 Tomos, 6 Bonos y el Sistema de Implementación Avanzado de Close The Gap" className="relative w-full h-auto max-h-[40vh] object-contain mx-auto drop-shadow-2xl" loading="eager" data-id="element-124" />
            </div>
          </motion.div>

          <motion.p variants={itemVariants} className="md:text-lg text-slate-300 mb-6 max-w-3xl mx-auto text-balance text-[20px]" data-id="element-125">
            El sistema N°1 para potenciar tu descanso... Cada noche que no
            dormís, es un día de tu vida que no vas a recuperar.
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-126">
            <Badge icon={<FileText size={16} data-id="element-128" />} text="100% PDF" data-id="element-127" />
            <Badge icon={<Zap size={16} className="text-amber-400" data-id="element-130" />} text="Acceso en 5 min" data-id="element-129" />
            <Badge icon={<Brain size={16} className="text-purple-400" data-id="element-132" />} text="Ciencia aplicada" data-id="element-131" />
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-center gap-4" data-id="element-133">
            <Button size="xl" href="#pricing" className="w-full sm:w-auto text-lg px-12" data-id="element-134">
              <span aria-hidden="true" className="mr-2" data-id="element-135">
                😴
              </span>{' '}
              → QUIERO MI MEGAPACK AHORA
            </Button>
            <p className="text-slate-400 flex items-center gap-2 text-[12px]" data-id="element-136">
              <span aria-hidden="true" data-id="element-137">🛡️</span> Garantía 7 días{' '}
              <span className="text-slate-600" data-id="element-138">|</span>{' '}
              <span aria-hidden="true" data-id="element-139">🔒</span> Pago seguro{' '}
              <span className="text-slate-600" data-id="element-140">|</span>{' '}
              <span aria-hidden="true" data-id="element-141">💳</span> Mercado Pago
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-slate-800/40 border border-white/5 text-sm font-medium text-slate-200 pl-[1px] pr-[1px]" data-id="element-142">
      {icon}
      <span className="text-[12px]" data-id="element-143">{text}</span>
    </div>;
}